import { render, staticRenderFns } from "./customer-repayment-schedule-en.vue?vue&type=template&id=3976803a&scoped=true&"
import script from "./customer-repayment-schedule-en.vue?vue&type=script&lang=js&"
export * from "./customer-repayment-schedule-en.vue?vue&type=script&lang=js&"
import style0 from "./customer-repayment-schedule-en.vue?vue&type=style&index=0&id=3976803a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976803a",
  null
  
)

export default component.exports